import type { PropsWithChildren } from 'react';
import { MacTrafficLightSlot } from './MacTrafficLightSlot';

/**
 * Draggable top strip for desktop screens that do not mount {@link TitleBar}
 * (auth gate, init loading). Reuses the `.titlebar` CSS region from the
 * desktop renderer stylesheet. Callers must only mount this on desktop —
 * Storybook/functional stories of the desktop gate also mount it so the
 * drag surface is assertable without Electron.
 *
 * Traffic lights are a sibling `no-drag` slot, not padding on the drag
 * surface — padding is still dragged and swallows the native close button.
 */
export function DesktopWindowChrome({
  children,
  macTrafficLights = true,
}: PropsWithChildren<{
  /** Reserve a no-drag hit target for macOS traffic lights. Default true. */
  macTrafficLights?: boolean;
}>) {
  return (
    <div className="flex h-screen w-full flex-col">
      <div className="flex h-12 shrink-0" data-testid="desktop-gate-titlebar">
        {macTrafficLights && <MacTrafficLightSlot />}
        <div className="titlebar min-w-0 flex-1" aria-hidden />
      </div>
      <div className="min-h-0 flex-1 overflow-auto">{children}</div>
    </div>
  );
}
